<app-loading [auto]="true" />

<div *ngIf="isLoginErrorRoute" class="min-h-screen bg-background-light-00">
  <router-outlet></router-outlet>
  <app-footer/>
</div>

<div
    id="app-container"
    [dir]="direction"
  *ngIf="pageLoaded && !isLoginErrorRoute"
  class="{{isInCanvas ? 'is-in-canvas' : ''}} {{ isInCanvas || isWebComponent ? '' : (AccountType.isCtop(userInfo.accountType) ? 'bg-background-light-00' : 'bg-background-light-01' )}} {{isWebComponent ? 'web-component-container' : ''}}"
>
    <div *ngIf="userInfo?.accountType" class="relative box-border w-full max-w-[1440px] mx-auto">
        <app-top-bar
            *ngIf="!isInCanvas"
          [isMobileMenuOpen]="isMobileMenuOpen"
          (onToggleMobileMenu)="toggleMobileMenu()"
        />
        <app-sidebar
            *ngIf="!isInCanvas"
          [activeItemCode]="activeItemCode"
          [isMobileMenuOpen]="isMobileMenuOpen"
          (onCloseMobileMenu)="toggleMobileMenu()"
        />

        <div
          *ngIf="!isWebComponent && !isMobileMenuOpen"
          class="box-border border-divider-divider"
          [ngClass]="{'md:pl-[120px] pt-[50px] pb-[31px] min-h-[100vh] border-r': !isInCanvas}"
          [style]="customStyle"
        >
            <ng-container *ngIf="!isWebComponent">
                <router-outlet></router-outlet>
            </ng-container>
        </div>

        <app-footer *ngIf="!isInCanvas" />
       <iframe
        *ngIf="!!iframeUrl"
        style="display:none;"
        [src]="iframeUrl"
        data-id="localstorageiframe"
        id="localstorageiframe">
      </iframe>
    </div>
</div>

